<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const route = useRoute();
const tabs = [
  { name: 'explore', group: ['explore', 'search'], path: 'M11 4a7 7 0 1 0 0 14 7 7 0 0 0 0-14z M20 20l-4-4' },
  { name: 'favorites', group: ['favorites'], path: 'M12 20s-7-4.5-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 10c0 5.5-7 10-7 10z' },
  { name: 'trips', group: ['trips', 'trip'], path: 'M4 7h16v12H4z M9 7V4h6v3' },
  { name: 'profile', group: ['profile', 'support', 'login'], path: 'M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8z M4 21a8 8 0 0 1 16 0' },
];
const active = computed(() => tabs.find((tab) => tab.group.includes(String(route.name)))?.name);
</script>

<template>
  <nav class="bottom-nav">
    <router-link v-for="tab in tabs" :key="tab.name" :to="{ name: tab.name }" class="item" :class="{ 'item--active': active === tab.name }">
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path :d="tab.path" /></svg>
      <span class="label">{{ t(`tabs.${tab.name}`) }}</span>
    </router-link>
  </nav>
</template>

<style scoped>
.bottom-nav {
  flex: none;
  display: flex;
  border-top: 1px solid var(--color-border-softer);
  background: var(--color-bg);
  padding: 9px 6px calc(12px + env(safe-area-inset-bottom));
  z-index: 7;
}
.item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
  color: var(--color-text-faint);
  text-decoration: none;
}
.item--active {
  color: var(--color-accent);
}
.label {
  font: 600 10px var(--font-sans);
}
</style>
